import _ from 'lodash';
export const name = 'INPADOC.render';
function renderDefault(h, renderOpts, params) {
    const { row, column } = params;
    const prop = _.get(column, 'property');
    const { PN, PATENT_ID } = row || {};
    const cellValue = _.get(row, prop);
    let link = null;
    if (cellValue > 1) {
        link = <span title={cellValue} data-link-type={prop} data-link-data={cellValue} data-patent-id={PATENT_ID} data-patent-no={PN}>
            {cellValue}
        </span>;
    }
    else {
        link = <span>{cellValue}</span>;
    }
    return [
        <div class="xtable-cell-render" cell-type={prop} cell-render={name}>
            {link}
        </div>,
    ];
}
// 导出模板，例如导出插槽中自定义的内容
function exportMethod(params) {
    const { row, column } = params;
    return row[column.property];
}
export default {
    renderDefault,
    exportMethod,
};
